import { RenderModal } from "../render-modal";
import { useCallback } from "react";
import { PlatformNoticeModalWrapper, PlatformNoticeWrapper } from "./atom";
import { Modal } from "task-eva-ui";
import { getTranslateNsT } from "./i18n";

export function PlatformNoticeModal({
  open = false,
  platformNotice = "",
  onClose,
}: {
  open: boolean;
  platformNotice: string;
  onClose: () => void;
}) {
  const t = getTranslateNsT();

  return (
    <Modal
      type="blank"
      open={open}
      render={
        <PlatformNoticeModalWrapper>
          <RenderModal
            title={t("overview_platform_notice")}
            onClose={onClose}
            haveConfirm={false}
            haveCancel={false}
            center
          >
            <PlatformNoticeWrapper column gap={16}>
              {platformNotice}
            </PlatformNoticeWrapper>
          </RenderModal>
        </PlatformNoticeModalWrapper>
      }
    />
  );
}
